import {getGeometry, getGeometryFlat, diameter, centroid} from "effects/midi/mappable/lang/geometry.js";

const dist = (x1,y1,x2,y2) => {
    return Math.sqrt(Math.pow(x1-x2, 2) + Math.pow(y1-y2, 2));
};
export const pt_dist = (a,b) => dist(a.x,a.y,b.x,b.y);

const distComp = (pt) => (a,b) => 
      dist(a.x,a.y,pt.x,pt.y) - dist(b.x, b.y, pt.x, pt.y);

const betweenScore = (pt, ptA, ptB) => {
    let score = 0;
    if (pt.x > ptA.x && pt.x < ptB.x) score++;
    if (pt.y > ptA.y && pt.y < ptB.y) score++;
    if (pt.x < ptA.x && pt.x > ptB.x) score++;
    if (pt.y < ptA.y && pt.y > ptB.y) score++;
    return score;
};

export const hullFromArray = (points) => {
    let centroid = getGeometryFlat(points);
    points.sort(POINT_COMPARATOR);
    let hull = makeHullFlat(points, centroid, 12);
    return hull;
};

export function makeHull(points, centroid, debug) {
    var newPoints = points.slice();
    newPoints.sort(POINT_COMPARATOR);
    let hull = makeHullPresorted(newPoints, centroid, debug);
    return hull;

    let nonHull = newPoints.filter(a => !hull.some(
        b => a.x === b.x && a.y === b.y));

    let adj = [...hull];
    for (let i=0; i < nonHull.length && i < hull.length; i++ ){
        let pt = nonHull[i];
        pt.other=true;
        let pos = 0;
        let minDist = undefined;

        for (let j=0; j < adj.length; j++) {
            let d = dist(pt.x,pt.y, adj[j].x,adj[j].y);
            if (minDist === undefined || d < minDist) {
                pos = j;
                minDist = d;
            }
        }

        let A = adj[mod(pos-1, adj.length)];
        let B = adj[pos];
        let C = adj[mod(pos+1, adj.length)];
        if (!adj[mod(pos+1, adj.length)].other && intersects(A, pt, B, C)) {
            adj.splice(mod(pos+1, adj.length), 0, pt);
        }  else {
            //if (!adj[pos].other) {
            adj.splice(pos, 0, pt);
            //}
        }
   }
    return adj;
}

function intersectsWithSelf(curvePoints) {
    let points = curvePoints;
    for (let i = 0; i < points.length - 1; i++) {
        let p1 = points[i]
        let p2 = points[i+1]
        
        for (let j = 0; j < points.length - 1; j++) {
            let p3 = points[j]
            let p4 = points[j+1]
            
            if (i !== j) {
                let inter = intersects(p1,p2, p3,p4);
                if (inter) { return true; }
            }
        }
    }
    return false
}

const ccw = (A,B,C) => 
      (C.y-A.y) * (B.x-A.x) > (B.y-A.y) * (C.x-A.x);

const intersects = (A,B,C,D) =>
      ccw(A,C,D) !== ccw(B,C,D) && ccw(A,B,C) !== ccw(A,B,D);


function makeHullPresorted(points, centroid, debug) {
    if (points.length <= 3) {
        return points;
    }
    let x = window.api.create_geometry_buffer(points.length);
    let y = window.api.create_geometry_buffer(points.length);
    let out = window.api.create_geometry_buffer(points.length*3+1);
    
    let xArray = new Uint32Array(points.map(({x,y}) => x));
    let yArray = new Uint32Array(points.map(({x,y}) => y));

    window.Module.HEAP32.set(xArray, x / xArray.BYTES_PER_ELEMENT);
    window.Module.HEAP32.set(yArray, y / yArray.BYTES_PER_ELEMENT);
    

    window.api.getConvexHull(x,y,points.length,out, centroid.x, centroid.y, debug);
    
    const resultView = new Uint32Array(window.Module.HEAP32.buffer, out, points.length*3+1);
    let size = resultView[0];
    let hull = [];
    for (let i=0; i < size;i++) {
        let x=resultView[2*i+1];
        let y=resultView[2*i+2];
        hull.push({x,y});
    }


    window.api.destroy_buffer(out);
    window.api.destroy_buffer(x);
    window.api.destroy_buffer(y);
    let rest = hull.slice(1, hull.length);
    rest.reverse();
    return [hull[0], ... rest];
}

function makeHullFlat(points, centroid, debug) {
    if (points.length <= 3) {
        return points;
    }
    let x = window.api.create_geometry_buffer(points.length);
    let out = window.api.create_geometry_buffer(points.length);
    
    window.Module.HEAPF32.set(points, x / points.BYTES_PER_ELEMENT);

    window.api.getConvexHullFlat(x,points.length,out, centroid.x, centroid.y, debug);
    
    const resultView = new Uint32Array(window.Module.HEAP32.buffer, out, points.length*3+1);
    let size = resultView[0];
    let hull = [];
    for (let i=0; i < size;i++) {
        let x=resultView[2*i+1];
        let y=resultView[2*i+2];
        hull.push({x,y});
    }

    window.api.destroy_buffer(out);
    window.api.destroy_buffer(x);
    let rest = hull.slice(1, hull.length);
    rest.reverse();
    return [hull[0], ... rest].flatMap(({x,y}) => [x,y]);
}


function POINT_COMPARATOR(a, b) {
    if (a.x < b.x)
        return -1;
    else if (a.x > b.x)
        return +1;
    else if (a.y < b.y)
        return -1;
    else if (a.y > b.y)
        return +1;
    else
        return 0;
}


const mod = (x,n) => {
    return ((x%n)+n)%n;
};
